import "./usagepage.scss";
import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Card, Container, Spacer, Toolbar, ToolIcon } from "uitoolkit";
import { useBodyStyle, usePageTitle } from "hooks";
import { useUsage } from "services/backend/usage";
import { GetUsageQuery } from "../../graphql/types";
import { Sidebar } from "components/sidebar";

// tslint:disable: typedef

export function UsagePage(props: {} & RouterProps) {
    //const [isLoading, setIsLoading] = useState(false);
    useBodyStyle("usagepage");
    usePageTitle("Usage");

    const usageResult = useUsage();

    return (
        <Container class="row grow maxheight-100vh overflow-y-hidden">
            <Sidebar />
            <Container class="flex-column overflow-y-auto grow">
                <Container class="p-4 pt-0 bg-primary gap-16 flex-column grow maxwidth">
                    <div style={{ paddingTop: "16px" }}>
                        <h2>Usage</h2>
                        <UsageTotalsCards usageResult={usageResult?.result} />
                    </div>
                </Container>
            </Container>
        </Container>
    );
}

export function UsageTotalsCards(props: { usageResult: GetUsageQuery | null | undefined }) {
    return (
        <Container class="row gap-16">
            <Card>
                <h2>Input tokens</h2>
                <div class="flex-row justify-content-end">
                    {
                        props.usageResult?.self?.usage?.total !== undefined ? props.usageResult.self.usage.total.inputTokens : <Fragment>&nbsp;</Fragment>
                    }
                </div>
            </Card>
            <Card>
                <h2>Output tokens</h2>
                <div class="flex-row justify-content-end">
                    {
                        props.usageResult?.self?.usage?.total !== undefined ? props.usageResult.self.usage.total.outputTokens : <Fragment>&nbsp;</Fragment>
                    }
                </div>
            </Card>
            <Card>
                <h2>Cost</h2>
                <div class="flex-row justify-content-end">
                    {
                        props.usageResult?.self?.usage?.total !== undefined ? ("$" + props.usageResult.self.usage.total.cost) : <Fragment>&nbsp;</Fragment>
                    }
                </div>
            </Card>
        </Container>
    );
}
